"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const components_1 = require("utils/components");
const classes = __importStar(require("./Pagination.module.scss"));
const hooks_1 = require("common/hooks");
const Pagination = ({ pageSize, setPageSize, pageIndex, gotoPage, previousPage, nextPage, canPreviousPage, canNextPage, pageCount, data, range, hasMore, fetching, filterComponent, }) => {
    const { formatMessage } = (0, hooks_1.useFormatter)();
    return (react_1.default.createElement(react_bootstrap_1.Stack, { direction: "horizontal", gap: 2 },
        setPageSize && (react_1.default.createElement("div", null,
            react_1.default.createElement(components_1.Select, { value: pageSize, onChange: (e) => {
                    setPageSize(Number(e.target.value));
                }, options: [5, 10, 20, 30, 50, 100].map((value) => {
                    return {
                        value: value.toString(),
                        label: `${value} ${formatMessage("Table.perPage")}`,
                    };
                }) }))),
        filterComponent && (react_1.default.createElement("div", { style: {
                width: "314px",
                maxWidth: "40%",
            } }, filterComponent)),
        react_1.default.createElement("div", { className: "ms-auto" },
            react_1.default.createElement(react_bootstrap_1.Pagination, { className: classes["pagination"] },
                react_1.default.createElement(components_1.Button, { className: classes["pageLink"], onClick: () => previousPage(), disabled: !canPreviousPage },
                    react_1.default.createElement("svg", { width: "7", height: "12", viewBox: "0 0 7 12", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                        react_1.default.createElement("path", { d: "M6 1L1 6L6 11", stroke: "white", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }))),
                react_1.default.createElement("div", { className: classes["pageItemContainer"] },
                    pageIndex !== 0 && (react_1.default.createElement(react_bootstrap_1.Pagination.Item, { onClick: () => gotoPage(0), linkClassName: classes["pageLink"] }, 1)),
                    pageIndex > 3 && (react_1.default.createElement(react_bootstrap_1.Pagination.Ellipsis, { disabled: true, linkClassName: classes["pageLink"] })),
                    pageIndex === 3 && (react_1.default.createElement(react_bootstrap_1.Pagination.Item, { onClick: () => gotoPage(1), linkClassName: classes["pageLink"] }, 2)),
                    pageIndex - 1 > 0 && (react_1.default.createElement(react_bootstrap_1.Pagination.Item, { onClick: () => previousPage(), linkClassName: classes["pageLink"] }, pageIndex)),
                    react_1.default.createElement(react_bootstrap_1.Pagination.Item, { active: true, linkClassName: classes["pageLink"] }, pageIndex + 1),
                    canNextPage && (react_1.default.createElement(react_bootstrap_1.Pagination.Item, { onClick: () => nextPage(), linkClassName: classes["pageLink"] }, pageIndex + 2)),
                    pageCount - pageIndex === 4 && (react_1.default.createElement(react_bootstrap_1.Pagination.Item, { onClick: () => gotoPage(pageCount - 2), linkClassName: classes["pageLink"] }, pageCount - 1)),
                    pageCount - pageIndex > 4 && (react_1.default.createElement(react_bootstrap_1.Pagination.Ellipsis, { disabled: true, linkClassName: classes["pageLink"] })),
                    pageIndex + 2 < pageCount && (react_1.default.createElement(react_bootstrap_1.Pagination.Item, { onClick: () => gotoPage(pageCount - 1), linkClassName: classes["pageLink"] }, pageCount))),
                react_1.default.createElement(components_1.Button, { className: classes["pageLink"], onClick: () => nextPage(), disabled: !canNextPage },
                    react_1.default.createElement("svg", { width: "7", height: "12", viewBox: "0 0 7 12", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                        react_1.default.createElement("path", { d: "M1 11L6 6L1 1", stroke: "white", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" })))))));
};
exports.default = Pagination;
